<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lxgp1">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
        <img :src="images.lxgp2">
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16.0pt;font-family:宋体;">CONTINUES CASTING MACHINE FOR STEEL BILLET</span>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lxgp1: require("../../../assets/img/common/lxgp1.jpg"),
        lxgp2: require("../../../assets/img/common/lxgp2.jpg")
      }
    };
  },

  components: {},
  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/lxgp.vue